import { getSafeUserRequestContext, getStoreInfoRequestContext } from '../context';
import { type ErrorBoosterGlobalAdditional } from './types';

/**
 * Общие поля браузерных Error Booster и серверных Error Booster/deploy-логов.
 * Новые общие признаки добавляются здесь и в ErrorBoosterGlobalAdditional:
 * обе точки отправки используют результат целиком. Неизвестные значения пропускаются.
 * @kind helper
 * @returns Известные общие поля из текущих контекстов пользователя и магазина.
 */
export function getErrorBoosterGlobalAdditional(): ErrorBoosterGlobalAdditional {
    const additional: ErrorBoosterGlobalAdditional = {};
    const { isInternalUser, storeSlug } = getSafeUserRequestContext();

    if (isInternalUser !== undefined) {
        additional.is_internal_user = isInternalUser;
    }

    if (storeSlug) {
        additional.store_slug = storeSlug;
    }

    try {
        additional.store_type = getStoreInfoRequestContext().type;
    } catch (_) {
        // Контекст магазина ещё не получен; UI fallback Kit не является данными для логов.
    }

    return additional;
}
